var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShop1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90713 0.101562L19.8066 1.51577L21.2208 11.4153L12.0284 20.6076C11.6379 20.9982 11.0048 20.9982 10.6142 20.6076L0.714772 10.7082C0.324243 10.3176 0.324243 9.68451 0.714772 9.29391L9.90713 0.101562ZM10.6142 2.22288L2.83609 10.001L11.3213 18.4863L19.0995 10.7082L18.0389 3.28354L10.6142 2.22288ZM12.7356 8.58681C11.9545 7.80579 11.9545 6.53946 12.7356 5.75841C13.5166 4.97737 14.7829 4.97737 15.564 5.75841C16.345 6.53946 16.345 7.80579 15.564 8.58681C14.7829 9.36791 13.5166 9.36791 12.7356 8.58681Z",
    fill: "#416EB2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop1);
export default __webpack_public_path__ + "static/media/shop-1.0f1e3b4124b34c414470c7dd1b4cc517.svg";
export { ForwardRef as ReactComponent };